import React, {useState} from 'react'
import { useHistory } from "react-router-dom";
import { newPass } from 'network/ApiAxios';
import {
    Button,
    Card,
    CardHeader,
    CardBody,
    FormGroup,
    Form,
    Input,
    Container,
    Row,
    Col,Alert
  } from "reactstrap";
import EditHeader from "components/Headers/EditHeader"

function NewPass() {
    const [password, setPassword] = useState("");
    const [password2, setPassword2] = useState("");
    const history = useHistory()
    const user = JSON.parse(localStorage.getItem("user"))

    const changePass = async (e) => {
        e.preventDefault();
        if(password==password2){
            const id = user._id;
            console.log(id)
            const response = await newPass( id, password );
            const { data } = response;
            if(data.success){
                history.push("/" + user.role + "/profile");
            }
        }
    }
        


  return (
    <>
      <EditHeader /> {/* Page content */}{" "}
      <Container className="mt--7" fluid>
        <Row>
          <div className="col">
            <Card className="bg-secondary shadow">
              <CardHeader className="bg-white border-0">
                <Row className="align-items-center">
                  <Col xs="8">
                    <h3 className="mb-0"> Change Password </h3>{" "}
                  </Col>{" "}
                  <Col className="text-right" xs="4">
                    <Button
                      color="primary"
                      type="submit"
                      form="myform"
                      //onClick={editUser}
                      size="sm"
                    >
                      Save{" "}
                    </Button>{" "}
                  </Col>{" "}
                </Row>{" "}
              </CardHeader>{" "}
              <CardBody>
                  {password!="" && password2!="" && password!=password2 ?
                    <Alert color="danger">
                        The passwords don't match
                    </Alert> : null}
                <Form id="myform" onSubmit={changePass}>
                  <div className="pl-lg-4">
                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-username"
                          >
                            Password{" "}
                          </label>{" "}
                          <Input
                            className="form-control-alternative"
                            value={password}
                            id="input-password"
                            placeholder="Password"
                            onChange={(e) => setPassword(e.target.value)}
                            type="text"
                          />
                        </FormGroup>{" "}
                      </Col>{" "}
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-email"
                          >
                            Repeat Password{" "}
                          </label>{" "}
                          <Input
                            className="form-control-alternative"
                            id="input-password2"
                            placeholder="Repeat Password"
                            value={password2}
                            onChange={(e) => setPassword2(e.target.value)}
                            type="text"
                          />
                        </FormGroup>{" "}
                      </Col>{" "}
                    </Row>{" "}
                  </div>{" "}
                </Form>{" "}
              </CardBody>{" "}
            </Card>{" "}
          </div>{" "}
        </Row>{" "}
      </Container>{" "}
    </>
  )
}

export default NewPass